<template>
  <div class="DiscoverPage">
    <!-- header start -->
    <van-nav-bar title="发现" fixed class="navbarBg" :border="false">
      <template #right>
        <div class="iconbtn"><van-icon name="search" @click="goSearch"/></div>
        <div class="iconbtn"><van-icon name="add-o" @click="goAddMemorialHall" /></div>
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-cell-group class="martop0">
      <!-- <van-cell center is-link to="/ObitList">
        <template slot="title">
          <div class="user-cell">
            <img src="@/assets/images/discover/obit.png">
            <span class="custom-title">在线讣告</span>
          </div>
        </template>
      </van-cell> -->
      <van-cell center is-link to="/BirthdayList">
        <template slot="title">
          <div class="user-cell">
            <img src="@/assets/images/discover/today.png">
            <span class="custom-title">忌日与诞辰</span>
          </div>
        </template>
      </van-cell>
      <van-cell center is-link to="/ArticleList">
        <template slot="title">
          <div class="user-cell">
            <img src="@/assets/images/discover/deeparticle.png">
            <span class="custom-title">深情感文</span>
          </div>
        </template>
      </van-cell>
      <van-cell center is-link to="/TotalMailbox">
        <template slot="title">
          <div class="user-cell">
            <img src="@/assets/images/discover/email.png">
            <span class="custom-title">时空信箱</span>
          </div>
        </template>
      </van-cell>
      <van-cell center is-link to="/AlbumList">
        <template slot="title">
          <div class="user-cell">
            <img src="@/assets/images/discover/photo.png">
            <span class="custom-title">时光留影</span>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
	export default {
	  data() {
	    return {

	    };
	  },
	  components: {
    },
		methods :{
			goSearch(){
        this.$router.push('/Search')
      },
			goAddMemorialHall(){
        this.$router.push('/Create')
      },
		},
	};
</script>

<style scoped>
.DiscoverPage{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 50px;
}
.user-cell{
  display: flex;
  align-items: center;
}
.user-cell img{
  width: 20px;
  height: 20px;
  margin-right: 14px;
  display: block;
  object-fit: contain;
}
</style>
